var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIptIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "\\uB808\\uC774\\uC5B4 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .b {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M16.23,4.78c1.02,0,1.86-.83,1.86-1.86s-.83-1.84-1.86-1.84-1.84.83-1.84,1.84c-.01,1.02.83,1.86,1.84,1.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M17.64,5.02h-2.77L10.15.3c-.37-.38-.98-.41-1.36-.03-.38.37-.41.98-.03,1.36l4.93,4.94v16.36c0,.59.47,1.07,1.07,1.07s1.07-.47,1.07-1.07v-8.87h.86v8.87c.01.59.49,1.07,1.08,1.07s1.07-.47,1.07-1.07V6.58s4.92-4.94,4.92-4.94c.37-.38.35-1-.03-1.36-.38-.37-1-.35-1.36.03l-4.7,4.71Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M9.25,11.8c-.25-.26-.6-.42-.99-.42h-3.51c-.39,0-.74.16-.98.42L.24,15.32c-.33.34-.31.89.03,1.21.34.33.89.31,1.21-.03l2.73-2.72v3.65H1.15c-.56,0-1.02.46-1.02,1.02,0,.29.11.55.31.74l3.44,3.44c.3.45.9.59,1.37.31.51-.29.67-.92.38-1.42l-1.96-1.96h.04s5.65,0,5.65,0l-1.96,1.96c-.28.5-.12,1.13.38,1.42.48.27,1.08.14,1.38-.31l3.45-3.44c.19-.18.31-.45.31-.74,0-.56-.46-1.02-1.02-1.02h-3.05v-3.61l2.68,2.69c.33.34.87.35,1.21.03.34-.33.35-.87.03-1.21l-3.52-3.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M6.53,11.03c.92,0,1.67-.75,1.67-1.67s-.75-1.67-1.67-1.67-1.67.75-1.67,1.67c0,.92.76,1.67,1.67,1.67Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIptIcon);
export default __webpack_public_path__ + "static/media/IPT-icon.add26c81ffc601e11ea8c92472f5167f.svg";
export { ForwardRef as ReactComponent };